module.exports = __webpack_public_path__ + "static/media/logo_wolfsburg.70c82c64.png";